!function (factory) {
  if (typeof module !== 'undefined') { module.exports = factory } else {
    define('app/models/seSurveyElementMdl',[
      'lodash',
      'backboneMdl',
      'app/app.utils',
      'app/config/constants'
    ], factory)
  }
}(function (
  _,
  BackboneBase,
  UTILS,
  CONSTANTS
) {

  var LOG_LABEL = 'SELM MDL'

  // CONSTANTS
  var VALATTR_DEFAULT = 'Display_Label',

    DEFAULT_PLACEHOLDER_XML_TYPE = 'Shadow',

    MSG_MISSING_VALUE_ERROR = CONSTANTS.VALUES.MSG_MISSING_VALUE_ERROR,

    DEFAULT_CONDITION = CONSTANTS.VALUES.DEFAULT_CONDITION,
    DEFAULT_COLUMN_LAYOUT = CONSTANTS.VALUES.DEFAULT_COLUMN_LAYOUT,
    DEFAULT_MATRIX_LAYOUT = CONSTANTS.VALUES.DEFAULT_MATRIX_LAYOUT,

    DEFAULT_GROUP_INPUT_TYPE = 'discrete',
    DEFAULT_GROUP_INPUT_ARRAY_TYPE = 'matrix',

    ELM_STATUS_DEFAULT = CONSTANTS.STATUS.LOADED,
    ELM_STATUS_DELETED = CONSTANTS.STATUS.DELETED

  // The big XML obj mace.
  var baseXmlTypes = {
      // input                    // group        //type         // data type                 // value attr       // default val for creation
      Scalar_Question: ['input', 'scalar', 'Level', VALATTR_DEFAULT, ''],
      Discrete_Question: ['input', 'discrete', 'Level', VALATTR_DEFAULT, ''],
      Multiple_Choice_Question: ['input', 'multiple', 'Level', VALATTR_DEFAULT, ''],
      Level: ['data', 'level', null, VALATTR_DEFAULT, 'Level'],

      MatrixMS: ['input_array', 'openmatrix', 'MatrixScalar', VALATTR_DEFAULT, ''],
      Matrix_Discrete_Question: ['input_array', 'matrix', 'Discrete_Question', VALATTR_DEFAULT, ''],
      AssociationMatrix: ['input_array', 'association', 'Multiple_Choice_Question', VALATTR_DEFAULT, ''],
      MatrixScalar: ['data', 'matrixscalar', 'Scalar_Question', VALATTR_DEFAULT, 'Attribute'],

      // empty temporary element used as placeholder e.g. for creation or updating data without knowing the later datatype
      Shadow: ['shadows', 'shadow', DEFAULT_PLACEHOLDER_XML_TYPE, VALATTR_DEFAULT, null],

      // passive
      Deck: ['passive', 'deck', null, 'num_items', 10],
      DerivedValue: ['passive', 'derived', null, '__derived__', ''],

      // control
      Branch: ['control', 'branch', null, 'PageId', ''],
      SegmentAssignment: ['control', 'segment', null, '__segment__', null],
      Close_Survey: ['control', 'close', null, 'Status', 7],

      // simple
      Commentary: ['simple', 'text', null, VALATTR_DEFAULT, null],
      Picture: ['simple', 'picture', null, 'Filename', null],
      RawHtml: ['simple', 'html', null, '__cdata__', ''],

      // experiment
      Scenario: ['experiment', 'experiment', null, 'ChoiceSetId', '']
    },
    saveAsTypes = {
      Commentary: 'RawHtml',
      Picture: 'RawHtml'
    },
    baseInputOptions = {},
    bIO = baseInputOptions

  // input
  baseInputOptions._base = ['type', 'condition', 'status']
  baseInputOptions._base_val = _.union(bIO._base, ['_value'])
  baseInputOptions._input = _.union(bIO._base_val, ['info', 'validate', 'optional'])
  baseInputOptions.scalar = _.union(bIO._input, ['description', 'alter_dimensions'])
  baseInputOptions._discrete = _.union(bIO._input, ['random', 'last_level_other', 'level_conditions'])
  baseInputOptions.discrete = _.union(bIO._discrete, ['description', 'column_layout'])
  baseInputOptions.multiple = _.union(bIO._discrete, ['column_layout', 'last_level_none'])
  baseInputOptions.level = ['type', 'info', '_value', 'condition']

  baseInputOptions._matrix = _.union(bIO._input, ['random', 'repeat_heading', 'long_question', 'attribute_conditions', 'level_conditions'])
  baseInputOptions.openmatrix = _.union(bIO._matrix, ['alter_dimensions'])
  baseInputOptions.matrix = _.union(bIO._matrix, ['matrix_layout'])
  baseInputOptions.association = _.union(bIO._matrix, [])
  baseInputOptions.matrixscalar = _.union(bIO._base_val, ['info', 'validate', 'level_conditions'])

  baseInputOptions.shadow = _.union(bIO._base_val, ['info', 'validate'])

  // passive
  baseInputOptions.deck = _.union(bIO._base_val, ['deck', 'sequential'])
  baseInputOptions.derived = _.union(bIO._base_val, ['derived'])

  // control
  baseInputOptions.branch = _.union(bIO._base_val, ['branch'])
  baseInputOptions.segment = _.union(bIO._base_val, ['info'])
  baseInputOptions.close = _.union(bIO._base_val, ['close'])

  // simple
  baseInputOptions.text = _.union(bIO._base_val, ['text_old'])
  baseInputOptions.picture = _.union(bIO._base_val, ['picture_old'])
  baseInputOptions.html = _.union(bIO._base_val, ['html_old'])

  // experiment
  baseInputOptions.experiment = _.union(bIO._base_val, ['experiment', 'designrow', 'experiment_rendered', 'validation_error'])

  /*
      baseInputObjModel = {
          type: "TypeName",
          info: {
              Display_Label:      "Display Label",
              Data_Description:   "Description",
              Data_Label:         "q1",
              Id:                 "1"
          },
          attr: {
              condition: {

              },
              validation: {
                  base: {
                      mendatory: 1,
                      message: "Base condition not met text"
                  },
                  custom: {
                      expr: null,   // "ex!=pression"
                      message: null       // "Custom condition not me"
                  }
              },
              layout: {
                  large: 0,
                  repeat_levels: 0,
                  dropdown: 0,
                  level_style: "1 column"
              },
              randomize: 0
          },
          data: []
      }

  */

  var SurveyElement = function (xmljsml) {

    function fixMultisplitCdata (jsmlRoot) {
      while (
        (jsmlRoot.length > 3 && _.isString(jsmlRoot[0]) && _.isObject(jsmlRoot[1])) ||
        (jsmlRoot.length > 2 && _.isString(jsmlRoot[0]) && _.isString(jsmlRoot[1]))) {

        jsmlRoot[jsmlRoot.length - 2] += jsmlRoot.pop()

      }
      return jsmlRoot
    }

    // HACKY fix for badly broken / parsed cdata HTML that is split into many text nodes
    // TODO: remove all JSML handling and replace by DOM handling --ab
    if (xmljsml && xmljsml.length) {
      switch (xmljsml[0]) {
        case 'RawHtml':
          fixMultisplitCdata(xmljsml)
          break
        case 'Scenario':
          if (xmljsml[2] && xmljsml[2][0] === 'Template') {
            fixMultisplitCdata(xmljsml[2])
          }
          if (xmljsml[3] && xmljsml[3][0] === 'Validation') {
            fixMultisplitCdata(xmljsml[3])
          }
          break
      }
    }

    var vars = {
        jsml: xmljsml || [DEFAULT_PLACEHOLDER_XML_TYPE, {}],
        model: {},
        _modelWrite: null,
        out: [],
        hadSpecialSettings: 0,
        timeofWriteOut: 0
      },
      _fn = {
        utils: {
          getConfig: function () {
            if (vars.model.type) return _fn.utils.getConfigByType(vars.model.type)
            else if (vars.jsml[0]) return _fn.utils.getConfigByXMLType(vars.jsml[0])
            else console.error(LOG_LABEL, 'no config type found', vars.model, vars.jsml)

            return null
          },
          getConfigByType: function (type) {
            var xmltype = _.findKey(baseXmlTypes, function (xmltypes) { return xmltypes[1] == type })
            if (!xmltype) {
              console.error(LOG_LABEL, 'bad type', type, xmltype)
              return null
            }
            return _fn.utils.getConfigByXMLType(xmltype)
          },
          getConfigByXMLType: function (xmltype) {
            if (!xmltype || !baseXmlTypes[xmltype]) {
              console.error(LOG_LABEL, 'bad xmltype', xmltype)
              return null
            }
            return {
              xmltype: xmltype,
              group: baseXmlTypes[xmltype][0],
              type: baseXmlTypes[xmltype][1],
              dataType: baseXmlTypes[xmltype][2],
              valueAttr: baseXmlTypes[xmltype][3],
              defaultVal: baseXmlTypes[xmltype][4]
            }
          },
          getOptions: function () {
            var config = _fn.utils.getConfig()
            return baseInputOptions[config.type]
          },
          getOptionsForOutput: function () { // TODO: make the saveAsTypes-feature auto working
            var config = _fn.utils.getConfig()

            if (saveAsTypes[config.xmltype]) {
              config = _fn.utils.getConfigByXMLType(saveAsTypes[config.xmltype])
            }

            return baseInputOptions[config.type]
          },
          find: function (type, jsml) {
            jsml = jsml || vars.jsml
            return jsml[_fn.utils.findIdx(type, jsml)]
          },
          findIdx: function (type, jsml) {
            jsml = jsml || vars.jsml
            //console.debug(LOG_LABEL, "findIdx .. in ..", type, jsml);
            return _.findIndex(jsml, function (elm) { return elm && elm[0] && elm[0] == type})
          },
          findAttr: function (type, attr, jsml) {
            jsml = jsml || vars.jsml

            var tmpElm = jsml[_fn.utils.findAttrIdx(type, attr, jsml)]
            return tmpElm ? tmpElm[1][attr] : null
          },
          findAttrIdx: function (type, attr, jsml) {
            jsml = jsml || vars.jsml
            return _.findIndex(jsml, function (elm) {
              return elm && elm[0] && elm[0] == type && !_.isUndefined(elm[1][attr])
            })
          },
          findByVal: function (type, attr, val, jsml) {
            jsml = jsml || vars.jsml

            return jsml[_fn.utils.findAttrIdxByVal(type, attr, val, jsml)]
          },
          findAttrByVal: function (type, attr, val, jsml) {
            jsml = jsml || vars.jsml

            var tmpElm = jsml[_fn.utils.findAttrIdxByVal(type, attr, val, jsml)]
            return tmpElm ? tmpElm[1][attr] : null
          },
          findAttrIdxByVal: function (type, attr, val, jsml) {
            jsml = jsml || vars.jsml
            return _.findIndex(jsml, function (elm) {
              return elm &&
                elm[0] &&
                elm[0] == type &&
                elm[1][attr] == val
            })
          },
          hasSpecialSetting: function () {
            /* TRUE if element has a value for one of the following:
                attr.condition
                attr.validate.mendatory
                attr.validate.custom
                attr.column_layout != '1 column'
                attr.layout.repeat_heading
                attr.layout.long_question
                attr.layout.levels_as_dropdown
                 attr.random
                 attr.attribute_conditions
                 attr.level_conditions
                 attr.dimensions
            */
            var attr = vars.model.attr,
              group = (_fn.utils.getConfig()).group,
              options = _fn.utils.getOptions()

            var
              hasSpecialSettings =
                attr.has_condition ||
                (attr.validate && (
                    attr.validate.is_optional ||
                    attr.validate.has_validation
                  )
                ) ||
                (attr.layout &&
                  (
                    (attr.layout.column_layout && attr.layout.column_layout !== DEFAULT_COLUMN_LAYOUT) ||
                    attr.layout.repeat_heading ||
                    attr.layout.long_question ||
                    (attr.layout.matrix_layout && attr.layout.matrix_layout !== DEFAULT_MATRIX_LAYOUT)
                  )
                ) ||
                attr.random ||
                attr.has_attribute_conditions ||
                attr.has_level_conditions ||
                attr.has_dimensions ||
                (vars.model.dataAttr &&
                  (vars.model.dataAttr.last_level_none ||
                    vars.model.dataAttr.last_level_other)
                )

            //console.debug(LOG_LABEL, "specialsetting",
            //    vars.model,
            //    attr,
            //    {
            //        condition: attr.condition,
            //        is_optional: (attr.validate && attr.validate.is_optional),
            //        custom: (attr.validate && attr.validate.custom),
            //        column: (attr.column_layout && attr.column_layout != '1 column'),
            //        repeat_header: attr.repeat_heading,
            //        long_question: attr.long_question,
            //        lad: attr.levels_as_dropdown,
            //        random: attr.random,
            //        attr_conditions: attr.attribute_conditions,
            //        level_conditions: attr.level_conditions
            //    },
            //    'has ?', hasSpecialSettings, hasSpecialSettings ? true:false, !!hasSpecialSettings);

            return hasSpecialSettings
          },

          /**
           * sets default values in the level conditions based on the currently set levels
           * -> fills them with "1 == 1" where no values are yet set
           */
          updateLevelConditions: function () {

            var config = _fn.utils.getConfig()

            var dataSElms = vars.model.data,
              dataVal = [],
              dataValSize = 0,

              levelConditions = vars.model.attr.level_conditions_value

            if (levelConditions) {

              dataVal = levelConditions.split('\n')
              dataValSize = vars.model.level_values.split('\n').length

            } else {

              if (config.group === 'input_array') {

                if (dataSElms &&
                  dataSElms.length > 0 &&
                  dataSElms[0]._model &&
                  dataSElms[0]._model.attr &&
                  dataSElms[0]._model.attr.level_conditions_value) {

                  dataVal = (dataSElms[0]._model.attr.level_conditions_value || '').split('\n')

                  dataValSize = dataSElms[0]._model.data.length

                }

              } else {
                dataVal = []
                _.forEach(dataSElms, function (tmpElm) {
                  var tmpVal = tmpElm._model.attr.condition || DEFAULT_CONDITION
                  dataVal.push(tmpVal)
                })

                dataValSize = dataSElms.length
              }

            }

            while (dataVal.length < dataValSize) {
              dataVal.push('')
            }

            dataVal = _.map(dataVal, function (val) {
              return val.trim() ? val : DEFAULT_CONDITION
            })

            dataVal = dataVal.join('\n')

            _fn.read._update({
              attr: {
                level_conditions_value: _.trimRight(dataVal)
              }
            })

            var hasConditions = _.trimRight(dataVal && dataVal.replace(new RegExp(DEFAULT_CONDITION, 'gm'), '')) !== ''

            return hasConditions

          },

          /**
           * sets default values in the attribute conditions based on the currently set attributes
           * -> fills them with "1 == 1" where no values are yet set
           */
          updateAttrConditions: function () {

            var dataSElms = vars.model.data,
              dataVal = [],
              dataValSize = dataSElms.length,

              attrConditions = vars.model.attr.attribute_conditions_value

            if (attrConditions) {

              dataVal = attrConditions.split('\n')
              dataValSize = vars.model.attribute_values.split('\n').length

            } else {

              _.forEach(dataSElms, function (tmpElm) {
                var tmpVal = tmpElm._model.attr.condition || DEFAULT_CONDITION
                dataVal.push(tmpVal)
              })

            }

            while (dataVal.length < dataValSize) {
              dataVal.push(DEFAULT_CONDITION)
            }

            dataVal = dataVal.join('\n')

            _fn.read._update({
              attr: {
                attribute_conditions_value: _.trimRight(dataVal)
              }
            })

            var hasConditions = !!_.trimRight(dataVal && dataVal.replace(new RegExp(DEFAULT_CONDITION, 'gm'), ''))

            return hasConditions

          },

          addUriBase: UTILS.addUriBase,
          removeUriBase: UTILS.removeUriBase,

          readCdata: function (cdataStr) {
            if (typeof cdataStr != 'string') return cdataStr

            return cdataStr.replace(/^<!\[CDATA\[/, '').replace(/\]\]>$/, '')
          }
        },
        read: {
          _update: function (updateObj) {
            var modelPre = UTILS.cloneObjNoLoop(vars.model) //_.clone(vars.model, true);

            //console.error(LOG_LABEL, "_update", updateObj, modelPre);

            if (updateObj.data !== undefined) { vars.model.data = [] }

            vars.model = _.merge(vars.model, updateObj)

            if (updateObj.attr) // extra merge necessary as sometimes deeplevel merges dont catch, e.g. attr.validate.custom
              vars.model.attr = _.merge(vars.model.attr, updateObj.attr)

            //vars.model = _.merge(vars.model, {_options:[]});
            //vars.model._options.splice(0, vars.model._options.length);
            //
            //_.forEach(updateObj._options || _fn.utils.getOptions(), function(opt, idx){
            //    //console.debug('########', opt, idx);
            //    vars.model._options.push(opt);
            //})

            //try{
            //    if(updateObj.attr.layout)
            //        console.log(LOG_LABEL, "read update", modelPre, updateObj, _.clone(vars.model, true));
            //}catch(err){}

            //console.debug(LOG_LABEL, "_update ext", updateObj.type, updateObj.xmltype, modelPre.xmltype);

            if (updateObj.type && (!updateObj.xmltype || updateObj.xmltype != modelPre.xmltype)) {
              _fn.read.type()

              if (updateObj._value === undefined)
                _fn.read._value()

              // on type change re-read all options
              if (modelPre.xmltype && modelPre.xmltype !== DEFAULT_PLACEHOLDER_XML_TYPE) {
                fn.toJsml() // write out current state into JSML
                _fn.read._options() // re-read state with updated options from JSML
                fn.toJsml() // write out new state with new options into JSML
              }

              //console.debug(LOG_LABEL, "read update ext.", _.clone(vars.model, true));
            }

          },
          _options: function () {
            var
              config = _fn.utils.getConfig(),
              options = _fn.utils.getOptions()

            if (!config || !options) return

            _.forEach(options, function (option) {
              switch (option) {
                case '_value':
                case 'info':
                  // dont re-read info or value
                  break
                default:
                  _fn.read[option]()
                  break
              }
            })
          },
          data: function (dataType) {
            if (!dataType) return
            var
              dataElms = _.filter(vars.jsml, function (elm) {
                return elm[0] == dataType
              }),
              config = _fn.utils.getConfig(),
              data = [],
              dataVal = ''

            _.forEach(dataElms, function (elm) {
              var
                tmpElm = new SurveyElement(elm),
                tmpVal = tmpElm._model._value || ''

              data.push(tmpElm)
              dataVal += tmpVal + '\n'
            })

            _fn.read._update({
              data: data
            })

            if (config.group == 'input_array') {
              // dataVal = Questions
              // data levels = Answers

              _fn.read._update({
                attribute_values: _.trimRight(dataVal),
                level_values: data.length ? data[0]._model.level_values : ''
              })

            } else {
              // dataVal = Answers

              _fn.read._update({
                level_values: _.trimRight(dataVal)
              })
            }

          },
          _value: function () {
            var config = _fn.utils.getConfig(),
              val

            switch (config.valueAttr) {
              case '__cdata__':

                var tmpStr = vars.jsml[2]
                if (typeof tmpStr === 'string') {
                  tmpStr = tmpStr.replace(/^<!\[CDATA\[/, '').replace(/\]\]>$/, '')
                }

                val = tmpStr

                if (window.$t && window.$t.assets_uri) { // TODO: change for better assets_uri handling
                  // set correct URI for images
                  val = _fn.utils.addUriBase(val, window.$t.assets_uri)

                }

                break
              case '__derived__':
                val = _fn.utils.findAttr('Expression', 'Value')

                break
              case '__segment__':
                val = vars.jsml[1]['Data_Label']

                break
              default:

                // remove itemAttr from info obj
                if (vars.model.info && vars.model.info[config.valueAttr])
                  delete (vars.model.info[config.valueAttr])
                val = vars.jsml[1] ? vars.jsml[1][config.valueAttr] : null

                // IF is "Commentary" -> also add new URIs for images
                if (config.type == 'text') {
                  if (window.$t && window.$t.assets_uri) { // TODO: change for better assets_uri handling
                    // set correct URI for images
                    val = _fn.utils.addUriBase(val, window.$t.assets_uri)
                  }
                }
                break
            }

            if (val === undefined || val === null || val === 'null') {
              val = config.defaultVal || ''
              //console.debug(LOG_LABEL, "read -> set default val", val, vars.model);
            }

            //console.debug(LOG_LABEL, 'READ _value()', val, config, config.valueAttr);

            _fn.read._update({
              _value: val
            })
          },
          status: function () {
            _fn.read._update({
              status: ELM_STATUS_DEFAULT
            })
          },
          type: function () {
            var config = _fn.utils.getConfig(),
              options = _fn.utils.getOptions(),
              optionsObj = [] // {};

            _.forEach(options, function (val) {
              //optionsObj[val] = 1;
              optionsObj.push(val)
            })

            var updData = {
              xmltype: config.xmltype,
              type: config.type,
              group: config.group,
              _options: optionsObj
            }

            _fn.read._update(updData)
            //console.debug (LOG_LABEL, "read", "type", updData);
          },
          condition: function () {
            var conditionStr = vars.jsml[1] ? vars.jsml[1].Condition : DEFAULT_CONDITION

            _fn.read._update({
              attr: {
                condition: conditionStr,
                has_condition: !!(conditionStr && conditionStr != DEFAULT_CONDITION)
              }
            })
          },
          /**
           * read level conditions
           * dependencies: must run after read.data()
           */
          level_conditions: function () {

            //var config = _fn.utils.getConfig();
            //
            //var dataSElms = vars.model.data, // already set during init process
            //    dataVal = "",
            //    tmpVal;
            //
            //if(config.group == "input_array"){
            //
            //    if(dataSElms &&
            //        dataSElms.length > 0 &&
            //        dataSElms[0]._model &&
            //        dataSElms[0]._model.attr &&
            //        dataSElms[0]._model.attr.level_conditions_value){
            //        dataVal = dataSElms[0]._model.attr.level_conditions_value || "";
            //    }
            //
            //}else{
            //    _.forEach(dataSElms, function(tmpElm){
            //        tmpVal = tmpElm._model.attr.condition || DEFAULT_CONDITION;
            //        dataVal += tmpVal + "\n";
            //    });
            //}
            //
            //_fn.read._update({attr: {
            //    level_conditions_value: _.trimRight(dataVal),
            //    has_level_conditions: !!(dataVal && dataVal.replace(new RegExp(DEFAULT_CONDITION,"g"), "").trimRight())
            //}});

            var hasLevelConditions = _fn.utils.updateLevelConditions()

            _fn.read._update({
              attr: {
                has_level_conditions: hasLevelConditions
              }
            })

          },
          /**
           * read attribute conditions
           * dependencies: must run after read.data()
           */
          attribute_conditions: function () {

            //var config = _fn.utils.getConfig(),
            //    dataType = config.dataType;
            //
            //var dataSElms = vars.model.data, // already set during init process
            //    dataVal = "",
            //    tmpVal;
            //
            //_.forEach(dataSElms, function(tmpElm){
            //    tmpVal = tmpElm._model.attr.condition || DEFAULT_CONDITION;
            //    dataVal += tmpVal + "\n";
            //});
            //
            //_fn.read._update({attr: {
            //    attribute_conditions_value: _.trimRight(dataVal),
            //    has_attribute_conditions: !!(dataVal && dataVal.replace(new RegExp(DEFAULT_CONDITION,"g"), "").trimRight())
            //}});

            var hasAttrConditions = _fn.utils.updateAttrConditions()

            _fn.read._update({
              attr: {
                has_attribute_conditions: hasAttrConditions
              }
            })
          },

          // input
          info: function () {
            if (vars.jsml[1]) {
              var infoObj = {
                display_label: vars.jsml[1].Display_Label,
                data_label: vars.jsml[1].Data_Label,
                data_value: vars.jsml[1].Value,
                id: vars.jsml[1].Id || vars.jsml[1].id || ''
              }

              if (!infoObj.data_label) {
                infoObj.data_label = infoObj.id ? 'q' + infoObj.id : ''
              }

            } else {
              //console.debug(LOG_LABEL, "read info", "no attributes found, setting defaults");

              var infoObj = {
                display_label: null,
                data_label: null,
                data_value: null,
                id: null
              }
            }

            //console.debug(LOG_LABEL, "NEW INFO", infoObj.id, infoObj, vars.jsml[1]);

            _fn.read._update({ info: infoObj })
          },
          description: function () {
            _fn.read._update({
              info: {
                description: vars.jsml[1].Data_Description
              }
            })
          },
          validate: function () {
            var valElm = _fn.utils.find('Validation'),
              valUserExprElm = _fn.utils.find('BoolUserExpression', valElm) || false,

              validateCustomObj = {
                expr: '',
                message: ''
              }

            if (valUserExprElm) {
              validateCustomObj.expr = (_fn.utils.find('Expression', valUserExprElm))[1].Value
              validateCustomObj.message = valUserExprElm[1].ErrorText
            }

            _fn.read._update({
              attr: {
                validate: {
                  custom: validateCustomObj,
                  has_validation: !!(validateCustomObj.expr)
                }
              }
            })

            _fn.read.validation_error()
          },
          validation_error: function () {
            var valElm = _fn.utils.find('Validation'),
              validationError = null

            if (valElm && valElm.length === 2 && _.isString(valElm[1])) {
              validationError = _fn.utils.readCdata(valElm[1])
            }

            _fn.read._update({
              attr: {
                validate: {
                  error: validationError
                }
              }
            })
          },
          optional: function () {
            var valElm = _fn.utils.find('Validation'),
              valMandatoryElm = valElm && _fn.utils.find('BoolMandatory', valElm),
              isMandatory = !!valMandatoryElm,
              isOptional = !isMandatory

            _fn.read._update({
              attr: {
                validate: {
                  is_optional: isOptional
                }
              }
            })
          },

          random: function () {
            var randomBool = vars.jsml[1].Randomise ? true : false

            _fn.read._update({
              attr: {
                random: randomBool
              }
            })
          },
          alter_dimensions: function () {
            var dimWidth = vars.jsml[1].Width,
              dimHeight = vars.jsml[1].Height

            if (dimWidth && dimHeight) {
              _fn.read._update({
                attr: {
                  has_dimensions: true,
                  dimensions: {
                    w: dimWidth,
                    h: dimHeight
                  }
                }
              })
            } else {
              _fn.read._update({
                attr: {
                  has_dimensions: false,
                  dimensions: {
                    w: 80,
                    h: 4
                  }
                }
              })
            }

          },
          last_level_other: function () {
            var lastLevelOtherDisplayLabel = _fn.utils.findAttr('Scalar_Question', 'Data_Label'),
              hasLastLevelOtherBool = lastLevelOtherDisplayLabel && lastLevelOtherDisplayLabel.match(/_other$/) ? true : false

            var lastLevelOtherId = hasLastLevelOtherBool ? _fn.utils.findAttr('Scalar_Question', 'Id') : null

            //console.debug(LOG_LABEL, "read lastlevel", tmpAttr, lastLevelOtherBool, vars.jsml);

            _fn.read._update({
              dataAttr: {
                last_level_other: hasLastLevelOtherBool,
                last_level_other_id: lastLevelOtherId,
                last_level_other_display_label: hasLastLevelOtherBool ? lastLevelOtherDisplayLabel : null
              }
            })
          },
          last_level_none: function () {
            var lastLevelNoneBool = vars.jsml[1] && vars.jsml[1].AllowNone ? true : false

            //console.debug(LOG_LABEL, "read lastlevelnone", lastLevelNoneBool, vars.jsml);

            _fn.read._update({
              dataAttr: {
                last_level_none: lastLevelNoneBool
              }
            })
          },

          column_layout: function () {
            var layoutElm = _fn.utils.find('Layout'),
              tmpAttrElm = _fn.utils.findByVal('Property', 'Name', 'level_style', layoutElm),
              tmpAttr = _fn.utils.findAttr('Property', 'Value', [tmpAttrElm])

            _fn.read._update({
              attr: {
                layout: {
                  column_layout: tmpAttr
                }
              }
            })
          },
          dragndrop_layout: function () {
            // handled via column_layout; level_style = dragndrop
          },
          repeat_heading: function () {
            var layoutElm = _fn.utils.find('Layout'),
              tmpAttr = _fn.utils.findAttrByVal('Property', 'Name', 'rl_layout', layoutElm)

            _fn.read._update({
              attr: {
                layout: {
                  repeat_heading: tmpAttr ? true : false
                }
              }
            })
          },
          long_question: function () {
            var layoutElm = _fn.utils.find('Layout'),
              tmpAttr = _fn.utils.findAttrByVal('Property', 'Name', 'lq_layout', layoutElm)

            _fn.read._update({
              attr: {
                layout: {
                  long_question: tmpAttr ? true : false
                }
              }
            })
          },
          // levels_as_dropdown: function(){
          //     var layoutElm = _fn.utils.find("Layout"),
          //         tmpAttr = _fn.utils.findAttrByVal("Property", "Name", "dropdown_layout", layoutElm);
          //
          //     _fn.read._update({attr: { layout: {
          //         levels_as_dropdown: tmpAttr ? true:false
          //     }}});
          // },
          matrix_layout: function () {

            var layoutElm = _fn.utils.find('Layout'),
              isDropdown = _fn.utils.findAttrByVal('Property', 'Name', 'dropdown_layout', layoutElm),
              isDragndrop = _fn.utils.findAttrByVal('Property', 'Name', 'dragndrop_layout', layoutElm),

              matrixLayout = DEFAULT_MATRIX_LAYOUT

            if (isDropdown) matrixLayout = 'dropdown'
            else if (isDragndrop) matrixLayout = 'dragndrop'

            _fn.read._update({
              attr: {
                layout: {
                  matrix_layout: matrixLayout
                }
              }
            })

          },

          // passive
          deck: function () {
            /*
             <Deck id="338" data_label="q338" num_items="10" Sequential="Y"></Deck>
             */
            var baseInfo = {
                id: vars.jsml[1].id,
                data_label: vars.jsml[1].data_label || 'q' + vars.jsml[1].id
              },
              value = vars.jsml[1].num_items

            _fn.read._update({
              info: baseInfo
            })
          },
          sequential: function () {
            /*
             <Deck id="338" data_label="q338" num_items="10" Sequential="Y"></Deck>
             */

            var sequentialBoolVal = vars.jsml[1].Sequential === 'Y'

            _fn.read._update({
              attr: {
                sequential: sequentialBoolVal
              }
            })
          },
          derived: function () {
            /*
             <DerivedValue id="339" data_label="q339">
                <Expression Value="1"/>
             </DerivedValue>
             */
            var baseInfo = {
                id: vars.jsml[1].id,
                data_label: vars.jsml[1].data_label || 'q' + vars.jsml[1].id
              },
              value = _fn.utils.findAttr('Expression', 'Value')

            _fn.read._update({
              info: baseInfo
            })
          },

          // control
          branch: function () {
            /*
             <Branch Id="333" PageId="P2"/>
             */
            var baseInfo = {
                id: vars.jsml[1].Id
              },
              value = vars.jsml[1].PageId

            _fn.read._update({
              info: baseInfo
            })
          },
          close: function () {
            /*
             <Close_Survey Id="104" Status="7"/>
             // complete = 7
             // screen out = 8
             */
            var baseInfo = {
                id: vars.jsml[1].Id
              },
              value = vars.jsml[1].Status

            _fn.read._update({
              info: baseInfo
            })
          },

          // simple
          text_old: function () {
            /*
             <Commentary Display_Label="Commentary Text" Id="64"></Commentary>
             */
            var baseInfo = {
                id: vars.jsml[1].Id
              },
              value = vars.jsml[1].Display_Label

            _fn.read._update({
              info: baseInfo
            })
          },
          text_html: function () {
            /*
             <Commentary Display_Label="Commentary Text" Id="64"></Commentary>
             */
            var baseInfo = {
                id: vars.jsml[1].Id
              },
              value = vars.jsml[1].Display_Label,
              textElm = $('<div><p>' + value + '</p></div>')

            _fn.read._update({
              info: baseInfo,
              html: $(textElm).html()
            })
          },
          picture_old: function () {
            /*
             <Picture Filename="" Display_Label="" Id="84" OrigWidth="1" OrigHeight="1" Width="0" Height="0"></Picture>
             */
            var baseInfo = {
                id: vars.jsml[1].Id,
                display_label: vars.jsml[1].Display_Label
              },
              imgInfo = {
                file: vars.jsml[1].Filename,
                size: {
                  width: vars.jsml[1].Width,
                  height: vars.jsml[1].Height
                },
                orig: {
                  width: vars.jsml[1].OrigWidth,
                  height: vars.jsml[1].OrigHeight
                }
              }

            _fn.read._update({
              info: baseInfo,
              image: imgInfo
            })
          },
          picture_html: function () {
            /*
             <Picture Filename="" Display_Label="" Id="84" OrigWidth="1" OrigHeight="1" Width="0" Height="0"></Picture>
             */
            var baseInfo = {
                id: vars.jsml[1].Id,
                display_label: vars.jsml[1].Display_Label
              },
              imgElm = $('<div><p><img></p></div>')

            $('img', imgElm)
              .attr('src', vars.jsml[1].Filename)
              .css('width', vars.jsml[1].Width)
              .css('height', vars.jsml[1].Height)

            _fn.read._update({
              info: baseInfo,
              html: $(imgElm).html()
            })
          }, // --------------- new picture object
          html_old: function () {
            /*
             <RawHtml Id="164">
                <![CDATA[ <span>Some custom HTML</span>	]]>
             </RawHtml>
             */
            var baseInfo = {
                id: vars.jsml[1].Id
              },
              value = vars.jsml[2]

            _fn.read._update({
              info: baseInfo,
              html: value // TODO: remove - deprecated by _value()
            })
          },
          html: function () {}, // --------------- new html object

          // experiment
          experiment: function () {
            /*
             <Scenario ChoiceSetId="new_experiment_1" Id="54" User_Scenario="3" DesignRow="5"/>
             */
            var baseInfo = {
              id: vars.jsml[1].Id
            }

            _fn.read._update({
              info: baseInfo
              //experiment: value // TODO: remove - deprecated by _value()
            })
          },
          designrow: function () {
            /*
             <Scenario ChoiceSetId="new_experiment_1" Id="54" User_Scenario="3" DesignRow="5"/>
             */
            var designrowVal = vars.jsml[1].DesignRow || ''

            _fn.read._update({
              designrow: designrowVal
            })
          },
          experiment_rendered: function () {
            var renderedHtmElm = _fn.utils.find('Template'),
              renderedHtml

            if (renderedHtmElm) {
              renderedHtml = _fn.utils.readCdata(renderedHtmElm[1])

            } else {
              var tmpStr = vars.jsml[2]
              if (tmpStr) {
                renderedHtml = _fn.utils.readCdata(tmpStr) // tmpStr.replace(/^<!\[CDATA\[/, "").replace(/\]\]>$/, "");
              }

            }

            _fn.read._update({
              html: renderedHtml
            })
          }
        },
        write: {
          _hadNoChanges: function () {
            //console.info("create obj hash");
            var modelCloneHash = UTILS.objHash(vars.model)
            //console.info("create obj hash - DONE", modelCloneHash, fn._hash, "changes?", modelCloneHash != fn._hash);
            return modelCloneHash == fn._hash
          },
          _reset: function () {
            fn._hash = UTILS.objHash(vars.model)

            //console.info("clone bare obj");
            vars._modelWrite = UTILS.cloneObjBare(vars.model) // _.clone(vars.model, true);
            //console.info("clone bare obj - DONE");

            if (!vars.out) {
              vars.out = []
            } else {
              vars.out.splice(0, vars.out.length)
            }
            vars.out.push('')
            vars.out.push({})
          },
          _attr: function (attrObj, baseElm) {
            baseElm = baseElm || vars.out
            baseElm[1] = _.merge(baseElm[1], attrObj)
          },
          /**
           * finds element of "baseType" or adds element to vars.out; returns found/created element
           * @param baseType
           * @returns {*}
           * @private
           */
          _base: function (baseType) {
            var valIdx = _fn.utils.findIdx(baseType, vars.out)

            if (valIdx == -1) {
              valIdx = vars.out.length
              vars.out.push([baseType])
            }

            return vars.out[valIdx]
          },
          _value: function () {
            var config = _fn.utils.getConfig(),
              val = vars._modelWrite._value

            //console.debug(LOG_LABEL, "write._value()", config.type, val);

            if (val === undefined || val === null) {
              val = config.defaultVal
              //console.debug(LOG_LABEL, "write -> set default val", val, _.clone(vars._modelWrite), true);
            }

            // also remove "empty" editor content
            if (_.isString(val) && UTILS.cleanupSemyEmptyHtml(val.trim()) == '') {
              val = ''
            }

            switch (config.valueAttr) {
              case '__cdata__':

                if (window.$t && $t.assets_uri) { // TODO: change for better assets_uri handling
                  // set correct URI for images
                  val = _fn.utils.removeUriBase(val, $t.assets_uri)
                }

                vars.out[2] = '<![CDATA[' + val + ']]>'

                break
              case '__derived__':
                var valOutIdx = _fn.utils.findIdx('Expression', vars.out)
                if (valOutIdx == -1) {
                  valOutIdx = vars.out.length
                  vars.out.push([])
                }

                vars.out[valOutIdx] = _.merge(vars.out[valOutIdx], ['Expression', {
                  Value: val
                }])

                break
              case '__segment__':

                vars._modelWrite.info.display_label = vars._modelWrite.info.data_label = val

                _fn.write._attr({
                  Data_Label: val,
                  Display_Label: val
                })

                break
              case 'ChoiceSetId':
              case 'PageId':
                // instead of 'just the id' ractivejs returns the full object here in _value
                // in such case the id must be taken from the object instead of saving the full
                // value of _value
                var tmpObj = {},
                  tmpVal = !val ? val :
                    val.id ? val.id : val

                tmpObj[config.valueAttr] = tmpVal
                _fn.write._attr(tmpObj)
                break
              default:
                if (config.type == 'text') {
                  if (window.$t && window.$t.assets_uri) { // TODO: change for better assets_uri handling
                    // set correct URI for images
                    val = _fn.utils.removeUriBase(val, window.$t.assets_uri)
                  }
                }

                var tmpObj = {}
                tmpObj[config.valueAttr] = val
                _fn.write._attr(tmpObj)
                break
            }

          },
          prepareData: function () {
            var config = _fn.utils.getConfig()

            if (saveAsTypes[config.xmltype]) {
              config = _fn.utils.getConfigByXMLType(saveAsTypes[config.xmltype])
            }

            if (!config.dataType) return

            var dataConfig = _fn.utils.getConfigByXMLType(config.dataType),
              dataValuesRaw,
              dataValues,
              tmpElm

            if (config.group == 'input_array') {
              // dataVal = Questions
              // data levels = Answers

              dataValuesRaw = vars._modelWrite.attribute_values

            } else {
              // dataVal = Answers

              dataValuesRaw = vars._modelWrite.level_values
            }

            if (dataValuesRaw !== undefined && dataValuesRaw.split) {

              // remove trailing empty lines
              dataValuesRaw = _.trimRight(dataValuesRaw)

              // split into values
              dataValues = dataValuesRaw.split('\n')

            } else {
              dataValues = []

            }

            //console.debug(LOG_LABEL, 'write.prepareData', dataValues);

            var oldData = vars._modelWrite.data || {},
              tmpOldElm

            vars._modelWrite.data = []

            _.forEach(dataValues, function (_value, idx) {
              var tmpId,
                tmpDatalabel,
                tmpLevelvalues

              tmpOldElm = oldData[idx]

              //console.debug(LOG_LABEL, "CREATE DATA", _value, idx, config.dataType, tmpOldElm);

              if (tmpOldElm &&
                tmpOldElm._model &&
                tmpOldElm._model.xmltype == config.dataType &&
                tmpOldElm._model._value == _value &&
                (config.group != 'input_array' || (tmpOldElm._model.level_values == vars._modelWrite.level_values))) {
                // if the type value and the level values are the same, just re-use old values

                //console.debug(LOG_LABEL, "CREATE DATA - old", tmpElm);

                tmpId = tmpOldElm._model.info.id
                tmpDatalabel = tmpOldElm._model.info.data_label

              } else {
                // otherwise create new Id and datalabel

                // if previous tmpId == integer -> increase
                if (tmpId == parseInt(tmpId)) {
                  tmpId = parseInt(tmpId) + 1
                } else {
                  // else create new Id based on parent Id
                  tmpId = vars._modelWrite.info.id + '_' + (idx + 1)
                }

                tmpDatalabel = vars._modelWrite.info.data_label + '_' + (idx + 1)

              }

              tmpElm = new SurveyElement([config.dataType, {}])
              tmpElm.update({
                info: {
                  id: tmpId,
                  data_label: tmpDatalabel
                },
                _value: _value
              })

              if (config.group == 'input_array') {
                tmpElm.update({
                  level_values: vars._modelWrite.level_values
                })
              }

              // save element state
              //tmpElm.toJsml();

              vars._modelWrite.data.push(tmpElm)
            })

            //console.debug(LOG_LABEL, 'write.prepareData', vars._modelWrite.data);

          },
          appendData: function () {
            var config = _fn.utils.getConfig()
            if (!config.dataType) return

            _.forEach(vars._modelWrite.data, function (tmpElm) {
              var tmpElmJsml = tmpElm.toJsml()
              //console.debug(LOG_LABEL, 'write.appendData', tmpElm, tmpElmJsml);

              vars.out.push(tmpElmJsml)
            })
          },
          // status is not exported to XML
          status: function () {},

          type: function (xmltype) {
            xmltype = xmltype || null

            if (!xmltype) {
              var config = _fn.utils.getConfig()
              xmltype = config.xmltype
            }

            //console.log(LOG_LABEL, "elm write", "type", xmltype, vars._modelWrite.type);

            vars.out[0] = xmltype
          },
          condition: function (condition) {
            if (condition == null) {
              if (vars._modelWrite.attr &&
                vars._modelWrite.attr.has_condition &&
                vars._modelWrite.attr.condition &&
                vars._modelWrite.attr.condition.trim() != DEFAULT_CONDITION) {
                condition = vars._modelWrite.attr.condition.trim()
              } else {
                return
              }
            }

            _fn.write._attr({ Condition: condition })
          },
          /**
           * write attribute conditions
           * dependencies: must run before write.appendData()
           */
          level_conditions: function () {

            var config = _fn.utils.getConfig()

            var level_conditions_value =
                vars._modelWrite.attr.has_level_conditions &&
                vars._modelWrite.attr.level_conditions_value || '',

              level_conditions = _.trimRight(level_conditions_value).split('\n')

            var dataSElms = vars._modelWrite.data

            if (config.group == 'input_array') {
              _.forEach(dataSElms, function (tmpElm) {
                tmpElm._model.attr.has_level_conditions = vars._modelWrite.attr.has_level_conditions
                tmpElm._model.attr.level_conditions_value = level_conditions_value
              })

            } else {
              _.forEach(dataSElms, function (tmpElm, idx) {
                var tmpVal = _.isEmpty(level_conditions[idx]) ? '' : level_conditions[idx].trim()
                if (tmpVal == DEFAULT_CONDITION) {
                  tmpVal = ''
                }
                tmpElm.update({
                  attr: {
                    condition: tmpVal,
                    has_condition: !!(tmpVal)
                  }
                })
              })
            }

          },
          /**
           * write attribute conditions
           * dependencies: must run before write.appendData()
           */
          attribute_conditions: function () {

            var attribute_conditions_value =
                vars._modelWrite.attr.has_attribute_conditions &&
                vars._modelWrite.attr.attribute_conditions_value || '',
              attribute_conditions = _.trimRight(attribute_conditions_value).split('\n')

            var dataSElms = vars._modelWrite.data

            _.forEach(dataSElms, function (tmpElm, idx) {
              var tmpVal = _.isEmpty(attribute_conditions[idx]) ? '' : attribute_conditions[idx].trim()
              if (tmpVal == DEFAULT_CONDITION) {
                tmpVal = ''
              }
              tmpElm.update({
                attr: {
                  condition: tmpVal,
                  has_condition: !!(tmpVal)
                }
              })
            })

          },
          // input

          info: function (infoObj) {
            infoObj = infoObj || vars._modelWrite.info

            if (!infoObj)
              return

            var attrObj = {
              Display_Label: infoObj.display_label,
              Data_Label: infoObj.data_label,
              Id: infoObj.id
              // Value:       infoObj.data_value  // is not written back into the object
            }

            _fn.write._attr(attrObj)
          },
          description: function (description) {
            if (description === undefined) {
              description = vars._modelWrite.info.description
            }

            _fn.write._attr({ Data_Description: description })
          },
          validate: function (validateObj) {
            /*
                 <Validation>
                    ...
                    <BoolUserExpression ErrorText="Message to Display when Validation Expression is false">
                        <Expression Value="Validation Expression"/>
                    </BoolUserExpression>
                 </Validation>
             */
            if (validateObj === undefined) {
              if (vars._modelWrite.attr &&
                vars._modelWrite.attr.validate) {
                validateObj = vars._modelWrite.attr.validate
              } else {
                return
              }
            }

            //console.debug(LOG_LABEL, 'write.validation', validateObj);

            if (!validateObj.custom ||
              !validateObj.has_validation ||
              !validateObj.custom.expr.trim()) return

            var valOut = _fn.write._base('Validation'),
              valCustIdx

            valCustIdx = _fn.utils.findIdx('BoolUserExpression', valOut)
            if (valCustIdx == -1) {
              valCustIdx = valOut.length
              valOut.push(null)
            }

            valOut[valCustIdx] = [
              'BoolUserExpression',
              {
                ErrorText: validateObj.custom.message
              },
              ['Expression', { Value: validateObj.custom.expr }]
            ]

            //console.debug(LOG_LABEL, 'write.validation out', valOut[valCustIdx], valOut, valCustIdx);
          },
          validation_error: function () {
            // no actual write ..
          },
          optional: function (validateObj) {
            /*
                 <Validation>
                    <BoolMandatory ErrorText="This item must be answered"/>
                    ...
                 </Validation>
             */

            if (validateObj === undefined) {
              validateObj = vars._modelWrite.attr.validate
            }

            //console.debug(LOG_LABEL, 'write.optional', validateObj);

            if (!validateObj || validateObj.is_optional) return

            var validationElm = _fn.write._base('Validation'),
              boolMandElmIdx

            boolMandElmIdx = _fn.utils.findIdx('BoolMandatory', validationElm)
            if (boolMandElmIdx === -1) {
              boolMandElmIdx = validationElm.length
              validationElm.push(null)
            }

            validationElm[boolMandElmIdx] = [
              'BoolMandatory',
              {
                ErrorText: MSG_MISSING_VALUE_ERROR
              }
            ]
          },
          random: function (isRandom) {
            if (isRandom === undefined) {
              isRandom = vars._modelWrite.attr.random
            }

            if (!isRandom) return

            _fn.write._attr({
              Randomise: 'y'
            })
          },
          alter_dimensions: function (dimensions) {
            /*
                <Scalar_Question Display_Label="Question Text with 50 x 3 dimensions?" Id="74" ...
                    Width="50" Height="3">...</Scalar_Question>
             */
            if (dimensions == undefined) {
              dimensions = vars._modelWrite.attr.has_dimensions ? vars._modelWrite.attr.dimensions : false
            }

            if (!dimensions) return

            _fn.write._attr({
              Width: dimensions.w,
              Height: dimensions.h
            })

          },
          last_level_other: function (lastLevelOtherBool) {
            /* -- adds additional scalar element
            ..
             <Scalar_Question Display_Label="1" Id="401" Data_Label="q264_other" Data_Description="1"></Scalar_Question>
             ..
             */
            if (lastLevelOtherBool == undefined) {
              if (vars._modelWrite.dataAttr &&
                vars._modelWrite.dataAttr.last_level_other) {
                lastLevelOtherBool = vars._modelWrite.dataAttr.last_level_other
              } else {
                return
              }
            }

            if (!lastLevelOtherBool) return

            var tmpElm = new SurveyElement(['Scalar_Question', {
              Id: vars._modelWrite.dataAttr.last_level_other_id || vars._modelWrite.info.id + '_other',
              Data_Label: vars._modelWrite.info.data_label + '_other',
              Data_Description: '1',
              Display_Label: '1'
            }])

            vars.out.push(tmpElm.toJsml())

          },
          last_level_none: function (lastLevelNoneBool) {
            if (lastLevelNoneBool == undefined) {
              if (vars._modelWrite.dataAttr &&
                vars._modelWrite.dataAttr.last_level_none) {
                lastLevelNoneBool = vars._modelWrite.dataAttr.last_level_none
              } else {
                return
              }
            }

            //console.debug(LOG_LABEL, "write lastlevelnone", lastLevelNoneBool, vars._modelWrite, vars.model);

            if (!lastLevelNoneBool) return

            //console.debug(LOG_LABEL, "write lastlevelnone", "write!");

            _fn.write._attr({
              AllowNone: 'y'
            })

            //console.debug(LOG_LABEL, "write lastlevelnone", "written", vars.out);
          },

          column_layout: function (columnLayout) {
            if (columnLayout == undefined) {
              if (vars._modelWrite.attr &&
                vars._modelWrite.attr.layout) {
                columnLayout = vars._modelWrite.attr.layout.column_layout
              } else {
                return
              }
            }

            //if(!columnLayout || columnLayout == DEFAULT_COLUMN_LAYOUT) return;
            if (!columnLayout) return

            var valOut = _fn.write._base('Layout'),
              valCustIdx

            valCustIdx = _fn.utils.findAttrIdx('Property', 'level_style', valOut)
            if (valCustIdx == -1) {
              valCustIdx = valOut.length
              valOut.push(null)
            }

            valOut[valCustIdx] = [
              'Property',
              {
                Name: 'level_style',
                Value: columnLayout
              }
            ]
          },
          dragndrop_layout: function () {
            // handled via column_layout; level_style = dragndrop
          },
          repeat_heading: function (repeatHeadingLayout) {
            if (repeatHeadingLayout == undefined) {
              if (vars._modelWrite.attr &&
                vars._modelWrite.attr.layout) {
                repeatHeadingLayout = vars._modelWrite.attr.layout.repeat_heading
              } else {
                return
              }
            }

            if (!repeatHeadingLayout) return

            var valOut = _fn.write._base('Layout'),
              valCustIdx

            valCustIdx = _fn.utils.findAttrIdx('Property', 'rl_layout', valOut)
            if (valCustIdx == -1) {
              valCustIdx = valOut.length
              valOut.push(null)
            }

            valOut[valCustIdx] = [
              'Property',
              {
                Name: 'rl_layout',
                Value: '1'
              }
            ]
          },
          long_question: function (longQuestionLayout) {
            if (longQuestionLayout == undefined) {
              if (vars._modelWrite.attr &&
                vars._modelWrite.attr.layout) {
                longQuestionLayout = vars._modelWrite.attr.layout.long_question
              } else {
                return
              }
            }

            if (!longQuestionLayout) return

            var valOut = _fn.write._base('Layout'),
              valCustIdx

            valCustIdx = _fn.utils.findAttrIdx('Property', 'lq_layout', valOut)
            if (valCustIdx == -1) {
              valCustIdx = valOut.length
              valOut.push(null)
            }

            valOut[valCustIdx] = [
              'Property',
              {
                Name: 'lq_layout',
                Value: '1'
              }
            ]
          },
          // levels_as_dropdown: function(levelAsDropdownLayout){
          //     if(levelAsDropdownLayout == undefined){
          //         if(vars._modelWrite.attr &&
          //             vars._modelWrite.attr.layout){
          //             levelAsDropdownLayout = vars._modelWrite.attr.layout.levels_as_dropdown;
          //         }else{
          //             return;
          //         }
          //     }
          //
          //     if(!levelAsDropdownLayout) return;
          //
          //     var valOut = _fn.write._base("Layout"),
          //         valCustIdx;
          //
          //     valCustIdx = _fn.utils.findAttrIdx("Property", "dropdown_layout", valOut);
          //     if(valCustIdx == -1){
          //         valCustIdx = valOut.length;
          //         valOut.push(null);
          //     }
          //
          //     valOut[valCustIdx] = [
          //         "Property",
          //         {
          //             Name: "dropdown_layout",
          //             Value: "1"
          //         }
          //     ];
          // },
          matrix_layout: function (matrixLayout) {
            if (matrixLayout === undefined) {
              if (vars._modelWrite.attr &&
                vars._modelWrite.attr.layout) {
                matrixLayout = vars._modelWrite.attr.layout.matrix_layout
              } else {
                return
              }
            }

            if (!matrixLayout || matrixLayout === DEFAULT_MATRIX_LAYOUT) {
              return
            }

            var valAttr

            switch (matrixLayout) {
              case 'dropdown':
                valAttr = 'dropdown_layout'
                break
              case 'dragndrop':
                valAttr = 'dragndrop_layout'
                break
            }

            if (!valAttr) return

            var valOut = _fn.write._base('Layout'),
              valCustIdx

            valCustIdx = _fn.utils.findAttrIdx('Property', valAttr, valOut)
            if (valCustIdx === -1) {
              valCustIdx = valOut.length
              valOut.push(null)
            }

            valOut[valCustIdx] = [
              'Property',
              {
                Name: valAttr,
                Value: '1'
              }
            ]

          },

          // passive
          deck: function () {
            /*
             <Deck id="338" data_label="q338" num_items="10" Sequential="Y"></Deck>
             */
            var attrObj = {
              id: vars._modelWrite.info.id,
              data_label: vars._modelWrite.info.data_label
            }

            _fn.write._attr(attrObj)
            //vars.out[1] = _.merge(vars.out[1], attrObj);
          },
          sequential: function () {
            /*
             <Deck id="338" data_label="q338" num_items="10" Sequential="Y"></Deck>
             */
            var sequentialVal = vars._modelWrite.attr.sequential ? 'Y' : false

            if (sequentialVal === false) return

            _fn.write._attr({
              Sequential: sequentialVal
            })
          },

          derived: function () {
            /*
             <DerivedValue id="339" data_label="q339">
                <Expression Value="1"/>
             </DerivedValue>
             */
            var attrObj = {
              id: vars._modelWrite.info.id,
              data_label: vars._modelWrite.info.data_label
            }

            _fn.write._attr(attrObj)
          },

          // control
          branch: function () {
            /*
             <Branch Id="333" PageId="P2"/>
             */
            var attrObj = {
              Id: vars._modelWrite.info.id,
              //    PageId: vars._modelWrite.targetPage
            }

            _fn.write._attr(attrObj)
          },
          close: function () {
            /*
             <Close_Survey Id="104" Status="7"/>
             // complete = 7
             // screen out = 8
             */
            var attrObj = {
              Id: vars._modelWrite.info.id,
              //    Status: vars._modelWrite.exitType
            }

            _fn.write._attr(attrObj)
          },

          // simple
          text_old: function () {
            /*
             <Commentary Display_Label="Commentary Text" Id="64"></Commentary>
             */
            var attrObj = {
              Id: vars._modelWrite.info.id,
              //    Display_Label: vars._modelWrite.text
            }

            _fn.write._attr(attrObj)
          },
          picture_old: function () {
            /*
             <Picture Filename="" Display_Label="" Id="84" OrigWidth="1" OrigHeight="1" Width="0" Height="0"></Picture>
             */
            var attrObj = {
              Id: vars._modelWrite.info.id,
              Display_Label: vars._modelWrite.info.display_label,
              //    Filename: vars._modelWrite.image.file,
              OrigWidth: vars._modelWrite.image.orig.width,
              OrigHeight: vars._modelWrite.image.orig.height,
              Width: vars._modelWrite.image.size.width,
              Height: vars._modelWrite.image.size.height
            }

            _fn.write._attr(attrObj)

          },
          picture: function () {}, // --------------- new picture object
          html_old: function () {
            /*
             <RawHtml Id="164">
                <![CDATA[ <span>Some custom HTML</span>	]]>
             </RawHtml>
             */

            var attrObj = {
              Id: vars._modelWrite.info.id
            }

            _fn.write._attr(attrObj)

            // vars.out[2] = "<![CDATA[ " + vars._modelWrite.html +  " ]]>";
          },
          html: function () {}, // --------------- new html object

          // experiment
          experiment: function () {
            /*
             <Scenario ChoiceSetId="new_experiment_1" Id="54"/>
             */
            var attrObj = {
              Id: vars._modelWrite.info.id
              //ChoiceSetId: vars._modelWrite.experiment // deprecated -- added via _value()
            }

            _fn.write._attr(attrObj)
          },
          designrow: function () {
            /*
             <Scenario ChoiceSetId="new_experiment_1" Id="54" User_Scenario="3" DesignRow="3"/>
             */
            var hasDesignrow = typeof vars._modelWrite.designrow !== 'undefined' && vars._modelWrite.designrow.trim() !== '',
              designrowVal = hasDesignrow ? vars._modelWrite.designrow.trim() : false

            if (hasDesignrow === false) return

            _fn.write._attr({
              DesignRow: designrowVal
            })
          },
          experiment_rendered: function () {
            // has no "write" functionality
          }
        }
      },
      fn = {
        _model: vars.model,
        _fields: vars.fields,
        _hash: null,
        //    _jsml: vars.jsml,
        id: function () {
          if (vars.model &&
            vars.model.info &&
            vars.model.info.id)
            return vars.model.info.id

          return vars.jsml && vars.jsml[1] ? vars.jsml[1].id || vars.jsml[1].Id : null
        },
        init: function () {
          var config = _fn.utils.getConfig(),
            options = _fn.utils.getOptions()

          if (!config || !options) return

          _fn.read.data(config.dataType)

          var readValue = false
          _.forEach(options, function (option) {
            if (option == '_value') {
              readValue = true
              return
            }
            _fn.read[option]()
          })

          if (readValue) {
            _fn.read._value()
          }

          vars.model.getOptions = function () { return _fn.utils.getOptions() }
          vars.model.hasSpecialSetting = function () { return _fn.utils.hasSpecialSetting() }
          vars.model.updateLevelConditions = function () { return _fn.utils.updateLevelConditions() }
          vars.model.updateAttrConditions = function () { return _fn.utils.updateAttrConditions() }

          _fn.write._reset()
          vars.out = _.clone(vars.jsml, true)

        },
        toJsml: function () {
          if (_fn.write._hadNoChanges()) {
            console.debug(LOG_LABEL, 'toJsml m')
            return vars.out
          }
          //console.debug(LOG_LABEL, "toJsml mw", config.xmltype);

          _fn.write._reset()

          _fn.write.prepareData()

          var options = _fn.utils.getOptionsForOutput()

          var writeValue = false
          _.forEach(options, function (option) {
            if (option == '_value') {
              writeValue = true
              return
            }
            //console.debug(LOG_LABEL, "elm out", "write option", option);
            _fn.write[option]()
          })
          //console.log(LOG_LABEL, "elm out", _.clone(vars.model, true), _.clone(vars.out), true);

          if (writeValue) {
            _fn.write._value()
          }

          _fn.write.appendData()

          //console.debug(LOG_LABEL, "toJsml out", vars.out);

          vars.timeofWriteOut = Date.now()

          vars.jsml = vars.out

          return vars.out
        },
        toJSON: function () {
          var jsonData = {}

          _.forEach(vars.model, function (val, attr) {
            var
              tmpVal,
              tmpData

            if (typeof val === 'function') {
              // ignore functions
              return

            } else if (attr === 'data') {
              tmpData = []
              _.forEach(val, function (val1) {
                var tmpVal1

                if (val1 && val1.toJSON)
                  tmpVal1 = val1.toJSON()
                else
                  tmpVal1 = ''
                tmpData.push(tmpVal1)
              })

              tmpVal = tmpData
            } else {

              tmpVal = _.clone(val, true)
            }

            jsonData[attr] = tmpVal

          })

          return jsonData
        },
        update: function (updateObj) {
          if (updateObj) {
            _fn.read._update(updateObj)
          }

          if (_fn.write._hadNoChanges()) {
            return false
          }

          // console.debug(LOG_LABEL, "elm.update",vars.model);
          // var newJsml = this.toJsml();

          //vars.jsml.splice(0);
          //_.forEach(newJsml, function(val, key){ vars.jsml[key] = val});

          return true
        },
        options: _fn.utils.getOptions,
        hasSpecialSetting: function () {
          var tmpHasSpecialSetting = _fn.utils.hasSpecialSetting()
          if (vars.timeofWriteOut > vars.hadSpecialSettings || tmpHasSpecialSetting) {
            // only update this negatively when in the meantime a writeOut happened
            vars.hadSpecialSettings = tmpHasSpecialSetting
          }

          return vars.hadSpecialSettings
        }

      }

    //window.setTimeout(fn.init, 5);
    fn.init()

    return fn
  }

  /**
   * parameter is an object with attributes
   *
   * jsml     read in a jsml object
   * - or -
   *
   * id       an id for the new element (leave empty if you dont have any yet)
   * type     the element type, e.g. 'input', 'deck', ...
   * value    the default value to be set
   *
   */

  var SurveyElementModel = BackboneBase.Model.extend({
    // basics
    defaults: {
      cid: null
    },
    selm: null,
    isTemporary: false,

    language: null,

    init: function (params, options) {
      var _this = this

      _this.set('cid', _this.cid)

      params = params || {}

      if (options && options.language) {
        _this.language = options.language
        _this.language.on('hasLoaded', function () {
          _this.translate()
        })
      }

      _this.parse(params.jsml)

      var _selm = _this.selm

      switch (params.type) {
        case undefined:
        case null:
          break

        case 'input':
          _selm.update({
            type: DEFAULT_GROUP_INPUT_TYPE
          })

          break
        case 'input_array':
          _selm.update({
            type: DEFAULT_GROUP_INPUT_ARRAY_TYPE
          })

          break
        case 'deck':
        case 'derived':
        default:
          _selm.update({
            type: params.type
          })
          break
      }

      var selmId = _.get(_selm._model, 'info.id')

      if (params.isTemporary) {
        _this.isTemporary = !!params.isTemporary
      }

      if (!selmId) {
        if (params.id) {
          selmId = params.id + ''
        } else {
          selmId = _this._newTemporaryId()
          _this.isTemporary = true
        }

        _.set(_selm._model, 'info.id', selmId)
      }

      _this.set('isTemporary', !!_this.isTemporary)

      if (params.value !== undefined) {
        _selm.update({ _value: params.value })
      }

      if (_this.isTemporary) {
        // set a default temporary label
        switch (params.type) {
          case 'input':
          case 'input_array':
          case 'deck':
          case 'derived':
            _selm.update({
              info: {
                data_label: CONSTANTS.PREFIX_TEMPORARY + selmId
              }
            })
            break
        }
      }

      _this.cset(_selm.toJSON())
      _this.translate()
      _this.setId(selmId)

      if (!_this.isTemporary) {
        _this.setStatus(CONSTANTS.STATUS.LOADED)
      }

      _this.on('change', function registerChangeFn (selmObj) {
        if (selmObj.isTemporary || selmObj.isDeleted || _this.isParsing) return

        var hasChanged = !!(_this.status == CONSTANTS.STATUS.CHANGED),
          newChange = false

        _.forEach(selmObj.changed, function (val, attr) {
          if (newChange) return

          if (attr.match(/^__/)) {
            return // ignore attributes that start with a "__" double underscore, used for non-saved-object values
          }

          var oldVal = selmObj._previousAttributes[attr]

          switch (attr) {
            case 'isActive':
            case 'isDeleted':
            case 'position':
            case 'status':
            case 'jsml':
              // ignore these attributes
              break
            case 'info':
              if (val.data_label === undefined) {
                break
              }
            case '_value':
            default:
              switch (typeof val) {
                case 'function':
                  // dont treat.
                  break
                case 'object':
                  newChange = !_.isEqual(val, oldVal)
                  break
                default:
                  newChange = (val + '').trim() != ((oldVal || '') + '').trim()
                  break
              }
          }

          if (attr === 'type' && newChange) {
            // on type change -> reset whole model

            var tmpJson = _this.toJSON({
              dataOnly: true,
              exclude: ['xmltype']
            })

            _selm.update(tmpJson)
            _this.merge(_selm.toJSON(), { silent: true })

          }
        })

        hasChanged = hasChanged || newChange

        if (hasChanged) {
          _this.updateTimestamp = Date.now()

          _this.trigger('hasChanged')
        }
      })

    },

    clone: function () {

      var _this = this,
        thisModel = _this.constructor

      return new thisModel({ jsml: _this.toJsml({ triggerIsSaving: false }) })

    },

    // read in

    parse: function (selmJsml) {
      var _this = this

      _this.selm = new SurveyElement(selmJsml)
      _this._latestJsml = selmJsml

      _this.isParsing = true
      _this.cset(_this.selm.toJSON())
      _this.translate()

      _this.isParsing = false

    },

    // parseValidation: function(selmJsml){
    //     var _this = this;
    //
    //     var validationHtmlStr = _.last(_.findWhere(selmJsml, function(jsml0){
    //                 return _.isArray(jsml0) && jsml0[0] === XML_ELEMENT_VALIDATION;
    //             }) || [""]) || null;
    //
    //     _this.set("errors", validationHtmlStr);
    //
    // },

    getValidationError: function () {
      var _this = this
      return _this.pget('attr.validate.error') || false
    },

    // write out

    _latestJsml: null,
    syncToSelm: function () {

    },
    toJsml: function (options) {
      var _this = this,
        _selm = _this.selm

      options = _.merge({
        triggerIsSaving: false
      }, options || {})

      if (_this.status !== CONSTANTS.STATUS.CHANGED) {
        if (_this._latestJsml) {
          return _this._latestJsml
        }
      }

      _selm.update(_this.toJSON({ dataOnly: true }))
      _this._latestJsml = _selm.toJsml()

      _this.merge(_selm.toJSON(), { silent: true })

      if (options.triggerIsSaving) {
        _this.trigger('isSaving')
        // on page save -> hasSaved is triggered.
        // all "saving" will be switched to "saved" then by base.status
      }

      return _this._latestJsml
    },

    toJSON: function (options) {
      var _this = this,
        attr = {}

      options = options || {
        dataOnly: false,
        exclude: [] // keys to exclude as array
      }

      _.forEach(_this.attributes, function (val, key) {
        switch (key) {
          case 'status':
          case 'position':
            // ignore on output
            break
          case 'id':
          case 'cid':
            if (options.dataOnly) {
              break // ignore if dataOnly is requested
            }
          default:
            if (!options.exclude || options.exclude.indexOf(key) === -1) {
              attr[key] = _.clone(val, true)
            }
            break
        }
      })

      // delete(attr.status);
      // delete(attr.position);

      return attr

    },

    // internal
    _newTemporaryId: function () {
      return Math.round(Date.now() * Math.random()) + ''
    },

    // actions

    resetId: function () {
      var _this = this

      var newId = _this._newTemporaryId()

      return _this.setId(newId, { keepOldReference: false })
    },

    setId: function (newId, options) {
      var _this = this,
        oldId = _this.id

      newId = newId + '' // always a string

      options = _.merge({
        keepOldReference: true
      }, options || {})

      if (options.keepOldReference) {
        _this.oldId = oldId

      } else {
        delete (_this.oldId)

      }

      _this.id = newId + ''

      if (_this.collection) {
        _this.collection._updateIdReference(oldId, newId, options)
      }

      _this.merge({
        id: newId,
        info: { id: newId }
      })

      return newId
    },

    setTemporary: function () {
      var _this = this

      var label = CONSTANTS.PREFIX_TEMPORARY + _this.id

      _this.pset('info.data_label', label)

      _this.isTemporary = true
      _this.set('isTemporary', true)
      _this.trigger('isTemporary')

    },

    unsetTemporary: function () {
      var _this = this

      var label = _this.pget('info.data_label')

      if (label &&
        label.match(new RegExp('^' + CONSTANTS.PREFIX_TEMPORARY))) {

        _this.pset('info.data_label', 'q' + _this.id)
      }

      setTimeout(function () { // delay this a little as "isTemporary" is used to trigger newElementFadeIn animation
        _this.isTemporary = false
        _this.set('isTemporary', false)
      }, 300)

    },

    hasSpecialSetting: function () {
      var _this = this

      var attr = _this.get('attr'),
        dataAttr = _this.get('dataAttr')

      var
        hasSpecialSettings =
          attr.has_condition ||
          (attr.validate && (
              attr.validate.is_optional ||
              attr.validate.has_validation
            )
          ) ||
          (attr.layout &&
            (
              (attr.layout.column_layout && !(attr.layout.column_layout === DEFAULT_COLUMN_LAYOUT)) ||
              attr.layout.repeat_heading ||
              attr.layout.long_question ||
              (attr.layout.matrix_layout && attr.layout.matrix_layout !== DEFAULT_MATRIX_LAYOUT)
            )
          ) ||
          attr.random ||
          attr.has_attribute_conditions ||
          attr.has_level_conditions ||
          attr.has_dimensions ||
          (dataAttr &&
            (dataAttr.last_level_none ||
              dataAttr.last_level_other)
          )

      return hasSpecialSettings

    },

    hasValue: function (str) {

      var _this = this,
        vals = [
          _this.pget('info.data_label'),
          _this.get('_value') || '',
          _this.get('level_values') || '',
          _this.get('attribute_values') || ''].join(' /// ').toLowerCase()

      vals = UTILS.stripHtmlTags(vals)

      if (typeof str !== 'string')
        return

      return vals.indexOf(str.toLowerCase()) !== -1

    },

    getOptions: function () {
      var _this = this,
        xmlType = _this.get('type')

      return baseInputOptions[xmlType]

    },

    setDeleted: function () {
      var _this = this

      _this.isDeleted = true // must be called before the .set, which will trigger the change:isDeleted
      _this.set('isDeleted', true)
      _this.trigger('isDeleted')
    },

    getNextNearbyNotDeletedSibling: function () {
      var _this = this

      if (!_this.collection) return

      var coll = _this.collection,
        thisIdx = _.findIndex(coll.models, function (selmObj) { return selmObj.id == _this.id }),
        maxIndex = coll.models.length - 1,
        searchIdx = thisIdx + 1,
        attempt = 0,
        nextNeighbour

      while (searchIdx >= 0) {
        // searches first all following neighbours and afterwards all previous

        nextNeighbour = coll.models[searchIdx]
        if (nextNeighbour && !nextNeighbour.isDeleted) {
          break
        }

        if (searchIdx >= maxIndex) {
          searchIdx = thisIdx - 1
        } else if (searchIdx > thisIdx) {
          searchIdx++
        } else {
          searchIdx--
        }
      }

      if (nextNeighbour && !nextNeighbour.isDeleted) {
        return nextNeighbour
      }

      return

    },

    translate: function (languageMdl) {
      var _this = this

      languageMdl = languageMdl || _this.language

      var info = _this.get('info')
      if (!languageMdl || !info) return

      var baseStringId = _this.pget('info.data_label') || _this.pget('info.id'),
        translations = languageMdl.getTranslations(baseStringId),

        hasChanged = false

      var wasParsing = _this.isParsing
      _this.isParsing = true

      _.each(translations, function (trObj) {
        var subIdData = trObj.subIdData

        switch (trObj.subtype) {
          case 'Validation':

            if (!_this.pget('attr.validate.custom.message_orig'))
              _this.pset('attr.validate.custom.message_orig', _this.pget('attr.validate.custom.message'))

            _this.pset('attr.validate.custom.message', trObj.value)

            break
          default:

            switch (subIdData.length) {
              case 1: // e.g. eq8 -> ._value

                _this.set('_value', trObj.value)

                break
              case 2: // e.g. eq8_1 -> .data[1]._value

                var tmp = _this.cget('data'),
                  idx0 = subIdData[1] - 1

                if (!tmp[idx0]) {
                  console.warn(LOG_LABEL, 'bad index on translate !?', tmp, subIdData, idx0)
                } else {
                  tmp[idx0]._value = trObj.value
                  _this.set('data', tmp)
                }

                break
              case 3: // e.g. eq8_1_2 -> .data[1].data[2]._value

                var tmp = _this.cget('data'),
                  idx0 = subIdData[1] - 1,
                  idx1 = subIdData[2] - 1

                if (!tmp[idx0] || !tmp[idx0].data[idx1]) {
                  console.warn(LOG_LABEL, 'bad index on translate !?', tmp, subIdData, idx0, idx1)
                } else {
                  tmp[idx0].data[idx1]._value = trObj.value
                  _this.set('data', tmp)
                }

                break
              default:
                console.warn(LOG_LABEL, 'something odd happened - 4 element string ID ?!', trObj, subIdData)
                break
            }

            break
        }

        hasChanged = true

      })

      _this.isParsing = wasParsing

      if (hasChanged) {
        _this.setStatus(CONSTANTS.STATUS.CHANGED)
        _this.trigger('change', _this)
      }

    }

  })

  return SurveyElementModel
})
;
